import React from "react";
import { withRouter } from "react-router-dom";
import { Body } from "../Certificates";
import { ContainerWrapper, SectionWrapper, ListUnstyled, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import Banner from "../Certificates/Components/Banner";

import "./index.css";

import bannerBig from "../../Images/min-1600-hero.jpg";
import bannerSmall from "../../Images/max-600-hero.jpg";
import TIMLogo from "../../Images/Network/TIM.jpg";
import CICLogo from "../../Images/Network/Canada_India.jpg";
import UnilagLogo from "../../Images/Network/Unilag.jpg";
import ESUTLogo from "../../Images/Network/ESUT.jpg";
import LTWLogo from "../../Images/Network/LTW.png";
import GCRLogo from "../../Images/Network/GCR.png";
import GEPICLogo from "../../Images/Network/GEPIC.jpg";
import HackingAwayLogo from "../../Images/Network/HackingAway.jpg";
import BayviewYardsLogo from "../../Images/Network/BayviewYards.jpg";
import CornwallLogo from "../../Images/Network/CICentre.png";
import TIMReviewlogo from "../../Images/Network/TIMReview.png";
import PublicSafetyLogo from "../../Images/Network/PublicSafety.jpg";
import BBBLogo from "../../Images/Network/BBB.jpg";
import CaPMLogo from "../../Images/Network/canada-coat-of-arms.svg";
import CIAPLogo from "../../Images/Network/CIAP.png";
import NgHCLogo from "../../Images/Network/NigeriaHC.png";
import APPMLogo from "../../Images/Network/APPM.jpg";


class GlobalGERS extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const name = "Global GERS";
    return (
      <div className="App">
        <HelmetTitle title="Global initiatives" />
        <Layout
          head={<Navbar />}
          body={
            <React.Fragment>
              <Banner certName={name} imgPathMin={bannerBig} imgPathMax={bannerSmall} />
              <Body logos={<NetworkGERS />} />
            </React.Fragment>
          }
        />
      </div>  
    );
  }  
}

const NetworkLogos = [
  {
    name: "Asia Pacific Professional Managers Association",
    url: "https://apac-pma.com",
    logo: APPMLogo
  },
  {
    name: "Technology Innovation Management Program, Carleton University",
    url: "https://timprogram.ca",
    logo: TIMLogo
  },
  {
    name: "Canada-India Centre for Excellence, Carleton University",
    url: "https://carleton.com/india",
    logo: CICLogo
  },
  {
    name: "Canada-India Accelerator Program",
    url: "https://ciaccelerate.ca",
    logo: CIAPLogo
  },
  {
    name: "University of Lagos",
    url: "https://unilag.edu.ng",
    logo: UnilagLogo
  },
  {
    name: "Enugu State University of Science and Technology",
    url: "https://esut.edu.ng",
    logo: ESUTLogo
  },
  {
    name: "Lead To Win",
    url: "https://leadtowin.ca",
    logo: LTWLogo
  },
  {
    name: "Global Cybersecurity Resource",
    url: "https://cugcr.ca",
    logo: GCRLogo
  },
  {
    name: "Global EPIC",
    url: "https://globalepic.org",
    logo: GEPICLogo
  },
  {
    name: "Public Safety Canada",
    url: "https://canada.ca",
    logo: PublicSafetyLogo
  },
  {
    name: "HackingAway.org",
    url: "https://hackingaway.org",
    logo: HackingAwayLogo
  },    
  {
    name: "Cours Bayview Yards",
    url: "https://bayviewyards.org",
    logo: BayviewYardsLogo
  },
  {
    name: "Cornwall Innovation Centre",
    url: "https://cornwallinnovation.ca",
    logo: CornwallLogo
  },
  {
    name: "TIM Review",
    url: "https://timreview.ca",
    logo: TIMReviewlogo
  },
  {
    name: "BigBlueButton",
    url: "https://bigbluebutton.org",
    logo: BBBLogo
  },
  {
    name: "Office of the Prime Minister of Canada",
    url: "https://pm.gc.ca",
    logo: CaPMLogo,
    event: "Prime Minister' visit",
    eventDate: "April 25, 2018",
  },
  {
    name: "Nigeria High Commision Ottawa",
    url: "https://nigeriahcottawa.ca",
    logo: NgHCLogo
  } 
];

function NetworkGERS () {
  return (
    <SectionWrapper backgroundColor="white" mt="3rem" mb="3rem" className="w-100">
      <ContainerWrapper textAlign="center">
        <ListUnstyled className="gers__logos d-flex flex--center">
          {
            NetworkLogos && NetworkLogos.sort((a, b) => {
              let a_ = a.name.toUpperCase();
              let b_ = b.name.toUpperCase();
              if (a_ < b_) { return -1; }
              if (a_ > b_) { return 1; }
              return 0;
            }).map((logo, index) => (
              <li className="gers__logos-item" key={logo.name.replace(/\s/g,'')} data-index={index}>
                <div className="gers__logos-item__logo">
                  <a href={logo.url} target="_blank" rel="noopener noreferrer">
                    <img src={logo.logo} alt={logo.name} title={logo.name} />
                  </a>
                </div>
                {logo.event && 
                  <div className="gers__logos-item__text">
                    <small>{logo.event}</small>
                    <small>{logo.eventDate}</small>
                  </div>
                }
              </li>
            ))
          }
        </ListUnstyled>
      </ContainerWrapper>
    </SectionWrapper>
  );
}


export default withRouter(GlobalGERS)



// WEBPACK FOOTER //
// ./src/Pages/GERSModel/GlobalGERS.js